module.exports = (__webpack_require__(15))(3);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/inherits.js from dll-reference vendor_library
// module id = 32
// module chunks = 0